import { render, staticRenderFns } from "./ToShowContent.vue?vue&type=template&id=05013d1a&scoped=true&"
import script from "./ToShowContent.vue?vue&type=script&lang=js&"
export * from "./ToShowContent.vue?vue&type=script&lang=js&"
import style0 from "./ToShowContent.vue?vue&type=style&index=0&id=05013d1a&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05013d1a",
  null
  
)

export default component.exports